// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { app, payload } from "modular-openscriptjs";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAJX_kbYzeT4KmNcruU1XBpvNesFHeOj9c",
    authDomain: "carata-29f2f.firebaseapp.com",
    projectId: "carata-29f2f",
    storageBucket: "carata-29f2f.appspot.com",
    messagingSenderId: "584850289679",
    appId: "1:584850289679:web:349587a4c41c8c16eb9f7a",
    measurementId: "G-QN0VSSKLV2",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(firebaseApp);

export const firebaseAuth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();

const broker = app("broker");
const $e = app("$e");

/**
 * Register for push notifications and get token
 */
export const getFirebaseToken = async (tries = 0) => {
    if (Capacitor.isNativePlatform()) {
        try {
            let permStatus = await PushNotifications.checkPermissions();

            if (permStatus.receive === 'prompt') {
                permStatus = await PushNotifications.requestPermissions();
            }

            if (permStatus.receive !== 'granted') {
                console.warn("Push notification permission not granted");
                return;
            }

            await PushNotifications.register();
        } catch (e) {
            console.error("Error registering for push notifications", e);
        }
        return;
    }

    // Web Platform
    if (!("Notification" in window) || Notification.permission !== "granted") {
        return;
    }

    const fcm = getMessaging(firebaseApp);

    getToken(fcm, {
        vapidKey: "BEahsfz0kc9hEFZpl00uq_aRrvCKc1_mh7P4dPWyUJr7GmHtWWnadpjhOdnfOGkXYuzrO9odrlytjdz6jyjCPkA",
    })
    .then((token) => {
        if (!token) return;

        broker.send($e.user.has.fcmToken, payload({ token }));

        onMessage(fcm, (payload) => {
            let n = payload.notification;
            let config = {
                body: n?.body,
                icon: n?.icon,
            };
            new Notification(n.title, config);
        });
    })
    .catch((e) => {
        if (tries < 3) {
            return getFirebaseToken(tries + 1);
        }
        console.error("Could not retrieve Messaging token due to ", e);
    });
};

// Capacitor Listeners
if (Capacitor.isNativePlatform()) {
    PushNotifications.addListener('registration', (token) => {
        broker.send($e.user.has.fcmToken, payload({ token: token.value }));
    });

    PushNotifications.addListener('registrationError', (error) => {
        console.error('Error on registration: ' + JSON.stringify(error));
    });

    PushNotifications.addListener('pushNotificationReceived', (notification) => {
        // console.log('Push received: ' + JSON.stringify(notification));
        // You can use a local notification plugin here if you want to show it explicitly
    });

    PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
        // console.log('Push action performed: ' + JSON.stringify(notification));
        const data = notification.notification.data;
        if (data && data.link) {
            //
        }
    });
}

broker.on([$e.system.has.notificationPermission], getFirebaseToken);
